import { render, staticRenderFns } from "./selectPlatform.vue?vue&type=template&id=c9f02768&scoped=true"
import script from "./selectPlatform.vue?vue&type=script&lang=js"
export * from "./selectPlatform.vue?vue&type=script&lang=js"
import style0 from "./selectPlatform.vue?vue&type=style&index=0&id=c9f02768&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9f02768",
  null
  
)

export default component.exports